import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetGroupsAction implements Action {
  public static readonly type = 'GetGroupsAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetGroupsAction.type;
}
